module.exports = __webpack_public_path__ + "static/hyperv_15.39480393.jpg";